import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/area`;
const readUrl = (url = "") => `${urlBase}${url}`;

export const postSubclientArea = async (areaBody) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(areaBody),
  });

  res = await parseJSON(res);

  return res.success;
};

export const patchSubclientArea = async (areaId, areaBody) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`/${areaId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(areaBody),
  });

  res = await parseJSON(res);

  return res.success;
};

export const updateAreaCentralizado = async (areaId, ClientId, areaBody) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/centralizado/${areaId}?ClientId=${ClientId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(areaBody),
  });

  res = await parseJSON(res);

  return res.success;
};
